
import { Component, Vue } from "vue-property-decorator";

import SignInForm from "@/components/auth/SignInForm.vue";
import SignUp from "./SignUp.vue";
import CompanyLogo from "@/components/icons/logo/logoSignUp.vue";
import SignInSignUpLogo from "@/components/icons/logo/SignInSignUpLogo.vue";
import SignUpIcon1 from "@/components/icons/SignUpIcon1.vue";
import SignUpIcon2 from "@/components/icons/SignUpIcon2.vue";
import SignUpIcon3 from "@/components/icons/SignUpIcon3.vue";
import ShakingParticles from '@/components/confetti/confetti.vue';
import "@/assets/css/signup.css"

@Component({
  components: {
    SignInForm,
    SignUp,
    CompanyLogo,
    SignUpIcon1,

    SignUpIcon2,
    SignUpIcon3, ShakingParticles, SignInSignUpLogo
  },
})
export default class SignIn extends Vue {

  companyRegistration = true;
  signIn = false;
  talentRegistration = false;
  activeClasses = "bg-yellowSignup border border-yellowSignup";
  companyRegistrationClasses = this.activeClasses;
  signInClasses = "";
  talentRegistrationClasses = "";

  sliderOne = true;
  sliderTwo = false;
  sliderThree = false;
  activeSlider = "w-6";
  sliderOneClasses = this.activeSlider;
  sliderTwoClasses = "";
  sliderThreeClasses = "";

  // Make use of routes to pick tab
  created(): void {
    let page = this.$route.query.page;
    if (page && page === "company") {
      this.showCompanyRegistrationSlot();
      return;
    }
    if (page && page === "talent") {
      this.showTalentRegistrationSlot();
      return;
    }
    this.showSignInSlot();
  }

  mounted() {
    let pagenum = 1;
    setInterval(() => {
      let allElements = document.getElementsByTagName('label');
      for (let i = 0, n = allElements.length; i < n; i++) {
        let myfor = allElements[i].getAttribute('for');
        if ((myfor !== null) && (myfor == ('slide_' + pagenum))) {
          allElements[i].click();
          break;
        }
      }
      if (pagenum == 4) {
        pagenum = 1;
      } else {
        pagenum++;
      }
    }, 4000)
  }

  showCompanyRegistrationSlot(): void {
    this.companyRegistration = true;
    this.signIn = false;
    this.talentRegistration = false;
    this.companyRegistrationClasses = this.activeClasses;
    this.signInClasses = "";
    this.talentRegistrationClasses = "";
  }
  showSignInSlot(): void {
    this.companyRegistration = false;
    this.signIn = true;
    this.talentRegistration = false;
    this.companyRegistrationClasses = "";
    this.signInClasses = this.activeClasses;
    this.talentRegistrationClasses = "";
  }
  showTalentRegistrationSlot(): void {
    this.companyRegistration = false;
    this.signIn = false;
    this.talentRegistration = true;
    this.companyRegistrationClasses = "";
    this.signInClasses = "";
    this.talentRegistrationClasses = this.activeClasses;
  }

  showsliderOneSlot(): void {
    this.sliderOne = true;
    this.sliderTwo = false;
    this.sliderThree = false;
    this.sliderOneClasses = this.activeSlider;
    this.sliderTwoClasses = "";
    this.sliderThreeClasses = "";
  }
  showsliderTwoSlot(): void {
    this.sliderOne = false;
    this.sliderTwo = true;
    this.sliderThree = false;
    this.sliderOneClasses = "";
    this.sliderTwoClasses = this.activeSlider;
    this.sliderThreeClasses = "";
  }
  showsliderThreeSlot(): void {
    this.sliderOne = false;
    this.sliderTwo = false;
    this.sliderThree = true;
    this.sliderOneClasses = "";
    this.sliderTwoClasses = "";
    this.sliderThreeClasses = this.activeSlider;
  }
}
